<div class="container-fluid" *ngIf="site">

    <customer-site-header StickyScroll
        [top]="true"
        [desktopOnly]="true"
        [site]="site"
        (clickEvent)="handleClick($event)"
        (searchJobs)="searchJobs()"
        [showBackButton]="showBackButton"
        [showSearchJobs]="true"
    >
        <a *ngIf="showBackButton"
            (click)="handleClick('cp_backresults')"
            (click)="backButton()"
        >
            <button class="header-button" OnHoverDarken [color]="site['theme']['buttonColor']">Back</button>
        </a>
    </customer-site-header>

</div>

<div id="content">
    <router-outlet></router-outlet>
</div>

<customer-site-footer *ngIf="site && site.settings && !site.settings.hideFooter" [site]="site" (clickEvent)="handleClick($event)">
  <div class="customer-site-footer-copy" *ngIf="site['footer']" >
    <div class="row" *ngFor="let section of site['footer']['sections']; let sectionIndex = index">
        <div *ngFor="let column of section['columns']; let columnIndex = index"
            class="col-xs-12"
            [class.col-sm-6]="section['columns'].length === 2"
            [class.col-sm-4]="section['columns'].length === 3"
            [innerHTML]="column.html | safe: 'html'">
        </div>
    </div>
  </div>
</customer-site-footer>
